import {MutationCache, QueryCache, QueryClient} from '@tanstack/react-query';

import {toast} from '@/components/ui/use-toast';
import {getErrorMessage} from '@/errors/getErrorMessage';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      networkMode: 'online',
      refetchOnReconnect: true,
    },
    mutations: {
      networkMode: 'online',
    },
  },
  queryCache: new QueryCache({
    onError: error => {
      const message = getErrorMessage(error);
      toast({
        title: message,
        variant: 'destructive',
      });
    },
  }),
  mutationCache: new MutationCache({
    onError: error => {
      const message = getErrorMessage(error);
      toast({
        title: message,
        variant: 'destructive',
      });
    },
  }),
});

export default queryClient;
